import { registerAction } from '../../Action'

const CLEAR_ERROR = 'CLEAR_ERROR'

const reducer = (state = {}, action) => {
  const { component, uuid } = action.payload
  const currentComponentErrors = state.errors && state.errors[component]
  const newComponentErrors = currentComponentErrors.filter(
    (error) => error.uuid !== uuid
  )

  return {
    ...state,
    errors: {
      ...state.errors,
      [component]: newComponentErrors,
    },
  }
}

const clearError = registerAction(CLEAR_ERROR, { reducer })

export default clearError
